import cn from 'classnames'

import LeftBody from 'src/icons/body-l.webp'
import RightBody from 'src/icons/body-r.webp'
import LeftHead from 'src/icons/left-head.webp'
import LeftLeftHand from 'src/icons/left-left-hand.webp'
import LeftRightHand from 'src/icons/left-right-hand.webp'
import Ship from 'src/icons/ship.webp'
import ShipLight from 'src/icons/ship-light.webp'
import RightHead from 'src/icons/right-head.webp'
import RightLeftHand from 'src/icons/right-left-hand.webp'
import RightRightHand from 'src/icons/right-right-hand.webp'
import Fish from 'src/icons/fish.webp'
import FishLight from 'src/icons/fish-light.webp'

import styles from './styles.module.scss'

interface IProps {
    position: 'left' | 'right'
}

export const Person = ({ position }: IProps) => {
    return (
        <div
            className={cn({
                [styles.wrapper_left_pers]: position === 'left',
                [styles.wrapper_right_pers]: position === 'right',
            })}
        >
            <img
                src={position === 'left' ? LeftBody : RightBody}
                alt={position === 'left' ? 'LeftBody' : 'RightBody'}
                className={styles.body}
            />

            <img
                src={position === 'left' ? LeftHead : RightHead}
                alt={position === 'left' ? 'LeftHead' : 'RightHead'}
                className={cn({
                    [styles.left_head]: position === 'left',
                    [styles.right_head]: position === 'right',
                })}
            />
            <img
                src={position === 'left' ? LeftLeftHand : RightLeftHand}
                alt={position === 'left' ? 'LeftLeftHand' : 'RightLeftHand'}
                className={cn({
                    [styles.left_left_hand]: position === 'left',
                    [styles.right_left_hand]: position === 'right',
                })}
            />
            <img
                src={position === 'left' ? LeftRightHand : RightRightHand}
                alt={position === 'left' ? 'LeftRightHand' : 'RightRightHand'}
                className={cn({
                    [styles.left_right_hand]: position === 'left',
                    [styles.right_right_hand]: position === 'right',
                })}
            />
            <div
                className={cn({
                    [styles.wrapper_ship]: position === 'left',
                    [styles.wrapper_fish]: position === 'right',
                })}
            >
                <img
                    src={position === 'left' ? Ship : Fish}
                    alt={position === 'left' ? 'Ship' : 'Fish'}
                    className={styles.toy}
                />
                <img
                    src={position === 'left' ? ShipLight : FishLight}
                    alt={position === 'left' ? 'ShipLight' : 'FishLight'}
                    className={cn({
                        [styles.ship_light]: position === 'left',
                        [styles.fish_light]: position === 'right',
                    })}
                />
            </div>
        </div>
    )
}
